var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getTimeDimensionName } from '@data/tag/tagUtil';
import { ConditionalFormatting, KpiColumnOperation, KpiColumnType, Period } from '@util/enums';
import { parseInterval } from '@util/helpers';
var INFIX = '/';
function isInInterval(startMonth, startYear, endMonth, endYear, itemMonth, itemYear) {
    return (((itemYear === startYear && itemMonth >= startMonth) || itemYear > startYear) &&
        ((itemYear === endYear && itemMonth <= endMonth) || itemYear < endYear));
}
var months = {
    Q1: [1, 2, 3],
    Q2: [4, 5, 6],
    Q3: [7, 8, 9],
    Q4: [10, 11, 12],
    H1: [1, 2, 3, 4, 5, 6],
    H2: [7, 8, 9, 10, 11, 12],
    YEAR: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
};
function getQTitlesAndMonths(month, usedMonths) {
    if (month === 3 && usedMonths.some(function (m) { return months.Q1.includes(m); })) {
        return {
            titleQ: "Q1",
            monthsQ: months.Q1,
        };
    }
    else if (month === 6 && usedMonths.some(function (m) { return months.Q2.includes(m); })) {
        return {
            titleQ: "Q2",
            monthsQ: months.Q2,
        };
    }
    else if (month === 9 && usedMonths.some(function (m) { return months.Q3.includes(m); })) {
        return {
            titleQ: "Q3",
            monthsQ: months.Q3,
        };
    }
    else if (month === 12 && usedMonths.some(function (m) { return months.Q4.includes(m); })) {
        return {
            titleQ: "Q4",
            monthsQ: months.Q4,
        };
    }
    else {
        return {
            titleQ: '',
            monthsQ: [],
        };
    }
}
function getHYTitlesAndMonths(month, usedMonths) {
    if (month === 6 && usedMonths.some(function (m) { return months.H1.includes(m); })) {
        return {
            titleHY: 'H1',
            monthsHY: months.H1,
        };
    }
    else if (month === 12 && usedMonths.some(function (m) { return months.H2.includes(m); })) {
        return {
            titleHY: 'H2',
            monthsHY: months.H2,
        };
    }
    else {
        return {
            titleHY: '',
            monthsHY: [],
        };
    }
}
function getKPIColumn(title, temporalTagIds, version) {
    return {
        hide: false,
        id: "".concat(title, "-").concat(version.id),
        title: title,
        subheader: "".concat(version.name),
        type: KpiColumnType.SELECTOR,
        tags: __spreadArray([version.versionTagId], __read(temporalTagIds), false),
    };
}
function getOptionData(op, periodName, yearTags, versionsById) {
    var _a;
    var optionVersion = versionsById[op.versionId];
    if (!optionVersion) {
        return;
    }
    var tag = (_a = op.tag) !== null && _a !== void 0 ? _a : yearTags.find(function (t) { return t.order === op.year; });
    var optionTitle = "".concat(periodName).concat(tag ? getTimeDimensionName(tag) : op.year);
    var opId = "".concat(optionTitle, "-").concat(op.versionId);
    return { opId: opId, optionTitle: optionTitle, optionVersion: optionVersion };
}
function generateDiffColumn(comparison, periodName, versionsById, diffColOperation, yearTags) {
    if (diffColOperation === void 0) { diffColOperation = KpiColumnOperation.DIFF_PERCENT; }
    var optionA = comparison.reverse ? comparison.optionB : comparison.optionA;
    var optionB = comparison.reverse ? comparison.optionA : comparison.optionB;
    var periodString = periodName !== '' ? "".concat(periodName).concat(INFIX) : '';
    var opAData = getOptionData(optionA, periodString, yearTags, versionsById);
    var opBData = getOptionData(optionB, periodString, yearTags, versionsById);
    if (!(opAData && opBData)) {
        return null;
    }
    return {
        hide: false,
        type: KpiColumnType.DIFF,
        opA: opAData.opId,
        opB: opBData.opId,
        operation: diffColOperation,
        title: "".concat(opAData.optionTitle, " vs. ").concat(opBData.optionTitle),
        subheader: "".concat(opAData.optionVersion.name, " vs. ").concat(opBData.optionVersion.name),
        id: "".concat(opAData.opId, "-vs-").concat(opBData.opId),
        conditionalFormatting: ConditionalFormatting.ARROWS,
    };
}
export function generateKPIColumns(periods, intervalStart, intervalEnd, yearVersions, comparisons, showSum, diffColOperation, activeYears, versionsById, internalTags) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var _e, _f, _g, _h, _j, _k, _l, _m;
    var monthTags = internalTags.months;
    var quarterTags = internalTags.quarters;
    var halfyearTags = internalTags.halfYears;
    var yearTags = internalTags.years;
    var ytdTags = internalTags.yearToDate;
    var _o = parseInterval(intervalStart, intervalEnd, activeYears), startMonth = _o.startMonth, startYear = _o.startYear, endMonth = _o.endMonth, endYear = _o.endYear;
    var hasMonth = periods.includes(Period.MONTH);
    var hasQ = periods.includes(Period.QUARTER);
    var hasHY = periods.includes(Period.HALFYEAR);
    var hasYear = periods.includes(Period.YEAR);
    var hasYtd = periods.includes(Period.YEAR_TO_DATE);
    var kpiColumns = [];
    var temporalFilter = [];
    var _loop_1 = function (year) {
        var yearTag = yearTags.find(function (y) { return y.name === "Y".concat(year); });
        if (yearTag !== undefined) {
            var tempFilterItemYear = {
                year: year,
                yearTagId: yearTag.id,
                monthTagIds: [],
            };
            var _loop_3 = function (month) {
                if (isInInterval(startMonth, startYear, endMonth, endYear, month, year)) {
                    var monthTag = monthTags.find(function (m) { return m.name === "M".concat(month); });
                    if (monthTag !== undefined) {
                        tempFilterItemYear.monthTagIds.push(monthTag.id);
                    }
                }
            };
            for (var month = 1; month <= 12; month++) {
                _loop_3(month);
            }
            temporalFilter.push(tempFilterItemYear);
        }
    };
    try {
        for (var activeYears_1 = __values(activeYears), activeYears_1_1 = activeYears_1.next(); !activeYears_1_1.done; activeYears_1_1 = activeYears_1.next()) {
            var year = activeYears_1_1.value;
            _loop_1(year);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (activeYears_1_1 && !activeYears_1_1.done && (_a = activeYears_1.return)) _a.call(activeYears_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var usedMonthsByYear = {};
    var _loop_2 = function (year) {
        var e_5, _r, e_6, _s;
        var yearComparisons = comparisons.filter(function (c) {
            return (c.optionA.year === year || c.optionB.year === year) && c.optionA.year <= year && c.optionB.year <= year;
        });
        var usedMonths = [];
        usedMonthsByYear[year] = usedMonths;
        var yearTag = yearTags.find(function (y) { return y.name === "Y".concat(year); });
        var yearTagName = yearTag !== undefined ? getTimeDimensionName(yearTag) : "".concat(year);
        var thisYearVersions = yearVersions[year];
        if (thisYearVersions === undefined) {
            return "continue";
        }
        var _loop_4 = function (month) {
            var e_7, _t, e_8, _u, e_9, _v, e_10, _w, e_11, _x, e_12, _y, e_13, _z, e_14, _0;
            if (isInInterval(startMonth, startYear, endMonth, endYear, month, year)) {
                usedMonths.push(month);
                // MONTH
                if (hasMonth) {
                    // normal column
                    var monthTag = monthTags.find(function (m) { return m.name === "M".concat(month); });
                    var monthTagName = monthTag !== undefined ? getTimeDimensionName(monthTag) : "M".concat(month);
                    if (yearTag !== undefined && monthTag !== undefined) {
                        try {
                            for (var thisYearVersions_2 = (e_7 = void 0, __values(thisYearVersions)), thisYearVersions_2_1 = thisYearVersions_2.next(); !thisYearVersions_2_1.done; thisYearVersions_2_1 = thisYearVersions_2.next()) {
                                var versionId = thisYearVersions_2_1.value;
                                var version = versionsById[versionId];
                                if (version === undefined) {
                                    continue;
                                }
                                kpiColumns.push(getKPIColumn("".concat(monthTagName).concat(INFIX).concat(yearTagName), [monthTag.id, yearTag.id], version));
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (thisYearVersions_2_1 && !thisYearVersions_2_1.done && (_t = thisYearVersions_2.return)) _t.call(thisYearVersions_2);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                    }
                    try {
                        // comparisons
                        for (var yearComparisons_2 = (e_8 = void 0, __values(yearComparisons)), yearComparisons_2_1 = yearComparisons_2.next(); !yearComparisons_2_1.done; yearComparisons_2_1 = yearComparisons_2.next()) {
                            var comparison = yearComparisons_2_1.value;
                            // skip if month is not present for both years
                            if (!((_e = usedMonthsByYear[comparison.optionA.year]) === null || _e === void 0 ? void 0 : _e.includes(month)) ||
                                !((_f = usedMonthsByYear[comparison.optionB.year]) === null || _f === void 0 ? void 0 : _f.includes(month))) {
                                continue;
                            }
                            var diffCol = generateDiffColumn(comparison, monthTagName, versionsById, diffColOperation, yearTags);
                            if (diffCol !== null) {
                                kpiColumns.push(diffCol);
                            }
                        }
                    }
                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                    finally {
                        try {
                            if (yearComparisons_2_1 && !yearComparisons_2_1.done && (_u = yearComparisons_2.return)) _u.call(yearComparisons_2);
                        }
                        finally { if (e_8) throw e_8.error; }
                    }
                }
                // YTD
                if (hasYtd) {
                    // normal column
                    var ytdTag = ytdTags.find(function (ytd) { return ytd.order === month; });
                    var ytdTagName = ytdTag !== undefined ? getTimeDimensionName(ytdTag) : "".concat(month);
                    if (yearTag !== undefined && ytdTag !== undefined) {
                        try {
                            for (var thisYearVersions_3 = (e_9 = void 0, __values(thisYearVersions)), thisYearVersions_3_1 = thisYearVersions_3.next(); !thisYearVersions_3_1.done; thisYearVersions_3_1 = thisYearVersions_3.next()) {
                                var versionId = thisYearVersions_3_1.value;
                                var version = versionsById[versionId];
                                if (version === undefined) {
                                    continue;
                                }
                                kpiColumns.push(getKPIColumn("".concat(ytdTagName).concat(INFIX).concat(yearTagName), [ytdTag.id, yearTag.id], version));
                            }
                        }
                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                        finally {
                            try {
                                if (thisYearVersions_3_1 && !thisYearVersions_3_1.done && (_v = thisYearVersions_3.return)) _v.call(thisYearVersions_3);
                            }
                            finally { if (e_9) throw e_9.error; }
                        }
                    }
                    try {
                        // comparisons
                        for (var yearComparisons_3 = (e_10 = void 0, __values(yearComparisons)), yearComparisons_3_1 = yearComparisons_3.next(); !yearComparisons_3_1.done; yearComparisons_3_1 = yearComparisons_3.next()) {
                            var comparison = yearComparisons_3_1.value;
                            // skip if month is not present for both years
                            if (!((_g = usedMonthsByYear[comparison.optionA.year]) === null || _g === void 0 ? void 0 : _g.includes(month)) ||
                                !((_h = usedMonthsByYear[comparison.optionB.year]) === null || _h === void 0 ? void 0 : _h.includes(month))) {
                                continue;
                            }
                            var diffCol = generateDiffColumn(comparison, ytdTagName, versionsById, diffColOperation, yearTags);
                            if (diffCol !== null) {
                                kpiColumns.push(diffCol);
                            }
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (yearComparisons_3_1 && !yearComparisons_3_1.done && (_w = yearComparisons_3.return)) _w.call(yearComparisons_3);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                }
            }
            // QUARTER
            if (hasQ) {
                var _1 = getQTitlesAndMonths(month, usedMonths), titleQ_1 = _1.titleQ, monthsQ_1 = _1.monthsQ;
                if (titleQ_1 !== '' && monthsQ_1.length > 0) {
                    // normal column
                    var quarterTag = quarterTags.find(function (q) { return q.name === titleQ_1; });
                    var quarterTagName = quarterTag !== undefined ? getTimeDimensionName(quarterTag) : "".concat(titleQ_1);
                    if (yearTag !== undefined && quarterTag !== undefined) {
                        try {
                            for (var thisYearVersions_4 = (e_11 = void 0, __values(thisYearVersions)), thisYearVersions_4_1 = thisYearVersions_4.next(); !thisYearVersions_4_1.done; thisYearVersions_4_1 = thisYearVersions_4.next()) {
                                var versionId = thisYearVersions_4_1.value;
                                var version = versionsById[versionId];
                                if (version === undefined) {
                                    continue;
                                }
                                kpiColumns.push(getKPIColumn("".concat(quarterTagName).concat(INFIX).concat(yearTagName), [quarterTag.id, yearTag.id], version));
                            }
                        }
                        catch (e_11_1) { e_11 = { error: e_11_1 }; }
                        finally {
                            try {
                                if (thisYearVersions_4_1 && !thisYearVersions_4_1.done && (_x = thisYearVersions_4.return)) _x.call(thisYearVersions_4);
                            }
                            finally { if (e_11) throw e_11.error; }
                        }
                    }
                    try {
                        // comparisons
                        for (var yearComparisons_4 = (e_12 = void 0, __values(yearComparisons)), yearComparisons_4_1 = yearComparisons_4.next(); !yearComparisons_4_1.done; yearComparisons_4_1 = yearComparisons_4.next()) {
                            var comparison = yearComparisons_4_1.value;
                            // skip if month is not present for both years
                            if (!((_j = usedMonthsByYear[comparison.optionA.year]) === null || _j === void 0 ? void 0 : _j.some(function (m) { return monthsQ_1.includes(m); })) ||
                                !((_k = usedMonthsByYear[comparison.optionB.year]) === null || _k === void 0 ? void 0 : _k.some(function (m) { return monthsQ_1.includes(m); }))) {
                                continue;
                            }
                            var diffCol = generateDiffColumn(comparison, quarterTagName, versionsById, diffColOperation, yearTags);
                            if (diffCol !== null) {
                                kpiColumns.push(diffCol);
                            }
                        }
                    }
                    catch (e_12_1) { e_12 = { error: e_12_1 }; }
                    finally {
                        try {
                            if (yearComparisons_4_1 && !yearComparisons_4_1.done && (_y = yearComparisons_4.return)) _y.call(yearComparisons_4);
                        }
                        finally { if (e_12) throw e_12.error; }
                    }
                }
            }
            // HALF YEAR
            if (hasHY) {
                var _2 = getHYTitlesAndMonths(month, usedMonths), titleHY_1 = _2.titleHY, monthsHY_1 = _2.monthsHY;
                if (titleHY_1 !== '' && monthsHY_1.length > 0) {
                    // normal column
                    var halfyearTag = halfyearTags.find(function (hy) { return hy.name === titleHY_1; });
                    var halfyearTagName = halfyearTag !== undefined ? getTimeDimensionName(halfyearTag) : "".concat(titleHY_1);
                    if (yearTag !== undefined && halfyearTag !== undefined) {
                        try {
                            for (var thisYearVersions_5 = (e_13 = void 0, __values(thisYearVersions)), thisYearVersions_5_1 = thisYearVersions_5.next(); !thisYearVersions_5_1.done; thisYearVersions_5_1 = thisYearVersions_5.next()) {
                                var versionId = thisYearVersions_5_1.value;
                                var version = versionsById[versionId];
                                if (version === undefined) {
                                    continue;
                                }
                                kpiColumns.push(getKPIColumn("".concat(halfyearTagName).concat(INFIX).concat(yearTagName), [halfyearTag.id, yearTag.id], version));
                            }
                        }
                        catch (e_13_1) { e_13 = { error: e_13_1 }; }
                        finally {
                            try {
                                if (thisYearVersions_5_1 && !thisYearVersions_5_1.done && (_z = thisYearVersions_5.return)) _z.call(thisYearVersions_5);
                            }
                            finally { if (e_13) throw e_13.error; }
                        }
                    }
                    try {
                        // comparisons
                        for (var yearComparisons_5 = (e_14 = void 0, __values(yearComparisons)), yearComparisons_5_1 = yearComparisons_5.next(); !yearComparisons_5_1.done; yearComparisons_5_1 = yearComparisons_5.next()) {
                            var comparison = yearComparisons_5_1.value;
                            // skip if month is not present for both years
                            if (!((_l = usedMonthsByYear[comparison.optionA.year]) === null || _l === void 0 ? void 0 : _l.some(function (m) { return monthsHY_1.includes(m); })) ||
                                !((_m = usedMonthsByYear[comparison.optionB.year]) === null || _m === void 0 ? void 0 : _m.some(function (m) { return monthsHY_1.includes(m); }))) {
                                continue;
                            }
                            var diffCol = generateDiffColumn(comparison, halfyearTagName, versionsById, diffColOperation, yearTags);
                            if (diffCol !== null) {
                                kpiColumns.push(diffCol);
                            }
                        }
                    }
                    catch (e_14_1) { e_14 = { error: e_14_1 }; }
                    finally {
                        try {
                            if (yearComparisons_5_1 && !yearComparisons_5_1.done && (_0 = yearComparisons_5.return)) _0.call(yearComparisons_5);
                        }
                        finally { if (e_14) throw e_14.error; }
                    }
                }
            }
        };
        for (var month = 1; month <= 12; month++) {
            _loop_4(month);
        }
        // YEAR
        if (hasYear && usedMonths.length > 0) {
            // normal column
            if (yearTag !== undefined) {
                try {
                    for (var thisYearVersions_1 = (e_5 = void 0, __values(thisYearVersions)), thisYearVersions_1_1 = thisYearVersions_1.next(); !thisYearVersions_1_1.done; thisYearVersions_1_1 = thisYearVersions_1.next()) {
                        var versionId = thisYearVersions_1_1.value;
                        var version = versionsById[versionId];
                        if (version === undefined) {
                            continue;
                        }
                        kpiColumns.push(getKPIColumn(yearTagName, [yearTag.id], version));
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (thisYearVersions_1_1 && !thisYearVersions_1_1.done && (_r = thisYearVersions_1.return)) _r.call(thisYearVersions_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
            try {
                // comparisons
                for (var yearComparisons_1 = (e_6 = void 0, __values(yearComparisons)), yearComparisons_1_1 = yearComparisons_1.next(); !yearComparisons_1_1.done; yearComparisons_1_1 = yearComparisons_1.next()) {
                    var comparison = yearComparisons_1_1.value;
                    var diffCol = generateDiffColumn(comparison, '', versionsById, diffColOperation, yearTags);
                    if (diffCol !== null) {
                        kpiColumns.push(diffCol);
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (yearComparisons_1_1 && !yearComparisons_1_1.done && (_s = yearComparisons_1.return)) _s.call(yearComparisons_1);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
    };
    try {
        for (var activeYears_2 = __values(activeYears), activeYears_2_1 = activeYears_2.next(); !activeYears_2_1.done; activeYears_2_1 = activeYears_2.next()) {
            var year = activeYears_2_1.value;
            _loop_2(year);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (activeYears_2_1 && !activeYears_2_1.done && (_b = activeYears_2.return)) _b.call(activeYears_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    if (showSum) {
        var sumTemp = [];
        try {
            for (var temporalFilter_1 = __values(temporalFilter), temporalFilter_1_1 = temporalFilter_1.next(); !temporalFilter_1_1.done; temporalFilter_1_1 = temporalFilter_1.next()) {
                var temporalFilterItem = temporalFilter_1_1.value;
                if (temporalFilterItem.monthTagIds.length > 0) {
                    sumTemp.push(temporalFilterItem);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (temporalFilter_1_1 && !temporalFilter_1_1.done && (_c = temporalFilter_1.return)) _c.call(temporalFilter_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var allActiveVersions = Object.values(yearVersions).reduce(function (activeVersions, thisYearVersions) {
            var e_15, _a;
            if (thisYearVersions !== undefined) {
                try {
                    for (var thisYearVersions_6 = __values(thisYearVersions), thisYearVersions_6_1 = thisYearVersions_6.next(); !thisYearVersions_6_1.done; thisYearVersions_6_1 = thisYearVersions_6.next()) {
                        var versionId = thisYearVersions_6_1.value;
                        activeVersions.add(versionId);
                    }
                }
                catch (e_15_1) { e_15 = { error: e_15_1 }; }
                finally {
                    try {
                        if (thisYearVersions_6_1 && !thisYearVersions_6_1.done && (_a = thisYearVersions_6.return)) _a.call(thisYearVersions_6);
                    }
                    finally { if (e_15) throw e_15.error; }
                }
            }
            return activeVersions;
        }, new Set());
        try {
            for (var _p = __values(allActiveVersions.values()), _q = _p.next(); !_q.done; _q = _p.next()) {
                var versionId = _q.value;
                var version = versionsById[versionId];
                if (version === undefined) {
                    continue;
                }
                kpiColumns.push({
                    hide: false,
                    id: "\u03A3-".concat(version.id),
                    temporalGenerator: sumTemp,
                    title: 'Σ',
                    subheader: version.name,
                    type: KpiColumnType.SELECTOR,
                    tags: [version.versionTagId],
                });
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_q && !_q.done && (_d = _p.return)) _d.call(_p);
            }
            finally { if (e_4) throw e_4.error; }
        }
    }
    return kpiColumns;
}
